import Button from "@Components/Button";
import styles from "./HeroContent.module.scss";
import PeopleReferredIcon from "@Icons/PeopleReferredIcon";
import PayoutDisbursedIcon from "@Icons/PayoutDisbursedIcon";
import { useDispatch, useSelector } from "react-redux";
import LoginDispatcher from "@Components/Login/actions";
import { AppState } from "@Store/index";
import SocialMediaBarDesktop from "../../../SocialMediaBar/SocialMediaBar";
import wrapperHOC from "@Utils/wrapperHOC";
import getReferralCode from "@Pages/Referral/helpers/ReferralCode/getReferralCode";
import { useState, useEffect } from "react";
import { logger } from "helpers/logger";
import gtagEventEmitter from "helpers/gtagEventEmitter";
import copyToClipboard from "@Pages/Referral/utils/copyToClipBoard";
import getFormattedSourceDetails from "@Utils/getFormattedSourceDetails";
import useTranslationHook from "hooks/useTranslationHook";

interface ReferralData {
  data: string;
  name: string;
}

const HeroContent = () => {
  const { t } = useTranslationHook();
  const dispatch = useDispatch();
  const loginDispatcher = new LoginDispatcher(dispatch);
  const [referralData, setReferralData] = useState<ReferralData | null>(null);

  const toggleLoginModal = () => {
    loginDispatcher.showLoginModal({ openingSource: "referral_programme" });
    gtagEventEmitter({
      action: "clicked_get_referral_link_hero",
      category: "referral_page",
    });
  };
  const { isUserLoggedIn, userData } = useSelector(({ appData }: AppState) => ({
    isUserLoggedIn: appData.isUserLoggedIn,
    userData: appData.userData,
  }));
  const fetchReferralCode = async (userid: any) => {
    try {
      const sourceDetails = getFormattedSourceDetails();
      const res: any = await getReferralCode(userid, sourceDetails);
      setReferralData(res);
    } catch (error) {
      logger.error(error);
    }
  };

  const useruid = userData?.data?.id;

  const onClickCopyToClipboard = () => {
    gtagEventEmitter({
      action: "copy_referral_code_clicked",
      category: "",
      email_id: userData?.email,
    });
    copyToClipboard(referralData, dispatch);
  };

  useEffect(() => {
    fetchReferralCode(useruid);
  }, []);

  return (
    <div className={styles.contentChildContainer}>
      <div className={styles.headingContainer}>
        <h1 className={styles.headingWrapper}>{t("referral.desktop.hero.heading")}</h1>
        <div className={styles.contentWrapper}>{t("referral.desktop.hero.subheading")}</div>
      </div>

      {!isUserLoggedIn && (
        <>
          <Button variant="none" className={styles.referralButton} onClick={toggleLoginModal}>
            {t("referral.desktop.hero.cta")}
          </Button>
          <div className={styles.refStatsContainer}>
            <div className={styles.refStatsChildContainer}>
              <div className={styles.refImageContainer}>
                <PeopleReferredIcon />
              </div>
              <div className={styles.refContentContainer}>
                <div className={styles.refContentHeading}>10,000+</div>
                <div className={styles.refContentSubHeading}>
                  {t("referral.desktop.hero.stats.referred")}
                </div>
              </div>
            </div>
            <div className={styles.refStatsDividor} />
            <div className={styles.refStatsChildContainer}>
              <div className={styles.refImageContainer}>
                <PayoutDisbursedIcon />
              </div>
              <div className={styles.refContentContainer}>
                <div className={styles.refContentHeading}>£500K+</div>
                <div className={styles.refContentSubHeading}>
                  {t("referral.desktop.hero.stats.payout")}
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {isUserLoggedIn && (
        <div className={styles.authenticatedContainer}>
          <div className={styles.authenticatedContainerHeading}>
            {t("referral.desktop.hero.yourlinkheading")}
          </div>
          <div className={styles.referralLinkContainer}>
            <div className={styles.linkContainerRow1}>{referralData?.data}</div>
            <div className={styles.linkContainerRow2}>
              <Button
                variant="none"
                className={styles.copyLinkCTA}
                onClick={onClickCopyToClipboard}
              >
                {t("referral.desktop.hero.copylink")}
              </Button>
              <SocialMediaBarDesktop referrerLink={referralData?.data} />
            </div>
          </div>
          <div className={styles.refStatsContainer}>
            <div className={styles.refStatsChildContainer}>
              <div className={styles.refImageContainer}>
                <PeopleReferredIcon color="#000" />
              </div>
              <div className={styles.refContentContainerWhite}>
                <div className={styles.refContentHeadingWhite}>10,000+</div>
                <div className={styles.refContentSubHeadingWhite}>
                  {t("referral.desktop.hero.stats.referred")}
                </div>
              </div>
            </div>
            <div className={styles.refStatsDividorWhite} />
            <div className={styles.refStatsChildContainerWhite}>
              <div className={styles.refImageContainerWhite}>
                <PayoutDisbursedIcon color="#000" />
              </div>
              <div className={styles.refContentContainerWhite}>
                <div className={styles.refContentHeadingWhite}>£500K+</div>
                <div className={styles.refContentSubHeadingWhite}>
                  {t("referral.desktop.hero.stats.payout")}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default wrapperHOC(HeroContent, {
  componentName: "HeroContent-ReferralDesktop",
  showForChina: true,
});
